import React, { useState, useRef, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Box,
    Stack,
    RadioGroup,
    Input,
    FormControl,
    FormLabel,
    Text,
    Avatar,
    IconButton,
    Divider,
    InputGroup,
    InputRightElement,
    Flex
} from '@chakra-ui/react';
import { IoIosAddCircle } from 'react-icons/io';
import { PiStethoscopeBold } from 'react-icons/pi';
import {
    useDoctorsQuery, useScriptRulesQuery, useCreateScriptMutation, useRegisterFamilyMemberToClinicMutation,
    useRegisterUserToClinicMutation,
} from '../graphql/types-and-hooks';
import { useBookAppointmentStore, useSearchClinicStore } from '../store';
import queryString from 'query-string';
import { Loading } from './Loading';
import { useRequestScriptStore } from '../store/requestScript';
import { Libraries } from '@react-google-maps/api';
import axios from 'axios';
// import { usePayments } from './../hooks/usePayments';
// import UserCreateSuccessModal from "./UserCreateSuccessModal";
import { FaCheck } from "react-icons/fa";
// eslint-disable-next-line
import PaymentStep from './PaymentStep';
import { useAlert } from './AlertProvider';
import { IoMdClose } from "react-icons/io";
import { logError } from "./logger";

const parsed = queryString.parse(window.location.search);

const USER_FK = parsed.cid;
const CLINIC_GROUP_CRM = parsed.gid;
const LOCATION_ID = parsed.lid;
// const APPT_ID = parsed.aid;

// eslint-disable-next-line
const libraries: Libraries = ['places'];



const RepeatScriptModal = ({ isOpen, onClose }) => {
    const [step, setStep] = useState(1);
    // eslint-disable-next-line
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [medications, setMedications] = useState([]);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const deliveryMethodObjRef = useRef(null);
    const [address, setAddress] = useState('');
    const [faxNumber, setfaxNumber] = useState('');
    const [email, setemail] = useState('');
    const [mobile, setmobile] = useState('');
    const [emailError, setEmailError] = useState('');
    // eslint-disable-next-line
    const [loadingSearchBox, setLoadingSearchBox] = useState(true);
    // eslint-disable-next-line
    const [validationError, setValidationError] = useState('');
    // eslint-disable-next-line
    const searchBoxRef = useRef<google.maps.places.SearchBox | null>(null);
    const [createScriptMutation] = useCreateScriptMutation();
    // eslint-disable-next-line
    const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
    const [isAddressValidated, setIsAddressValidated] = useState(false);
    const { showAlert } = useAlert();



    const [
        registerUserToClinicMutation,
    ] = useRegisterUserToClinicMutation();

    const [
        registerFamilyMemberToClinicMutation,
    ] = useRegisterFamilyMemberToClinicMutation();

    useEffect(() => {
        if (isOpen) {
            // Send a message to the parent window to scroll to the top
            window.parent.postMessage({ action: 'scrollToTop' }, '*');
        }
    }, [isOpen]);

    // eslint-disable-next-line
    const [clinic] = useSearchClinicStore(state => [state.clinic]);

    // eslint-disable-next-line
    const [patient, doctor, patientId, medication, setData, resetData] = useRequestScriptStore((state) => [
        state.patient,
        state.doctor,
        state.patientId,
        state.medication,
        state.setData,
        state.resetData,
    ]);

    // eslint-disable-next-line
    const [patient1, clinic1, setData1, resetData1] = useBookAppointmentStore((state) => [
        state.patient,
        state.clinic,
        state.setData,
        state.resetData,
    ]);

    const { data: scriptRulesData } = useScriptRulesQuery({
        variables: {
            input: {
                clinic_group_crm: CLINIC_GROUP_CRM,
                user_fk: USER_FK,
            },
        },
    });

    //let patientId = null;

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setemail(newEmail);

        if (!validateEmail(newEmail)) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
    };

    const removeMedication = (index) => {
        const updatedMedications = medications.filter((_, i) => i !== index);
        setMedications(updatedMedications);
    };


    const registerPatient = async () => {
        let id;
        if (patient1.family_member_key) {
            try {
                const result = await registerFamilyMemberToClinicMutation({
                    variables: {
                        input: {
                            clinic_group_crm: CLINIC_GROUP_CRM,
                            user_fk: USER_FK,
                            location_id: LOCATION_ID,
                            family_member_key: parseInt(patient1.family_member_key),
                        },
                    },
                });

                id = result?.data?.registerFamilyMemberToClinic?.patient_id;

            } catch (error) {
                logError("bookAppointmentRegisterError", error);
                console.error("bookAppointmentRegisterError", JSON.stringify(error, null, 2));
            }
        } else {
            try {
                const result = await registerUserToClinicMutation({
                    variables: {
                        input: {
                            clinic_group_crm: CLINIC_GROUP_CRM,
                            user_fk: USER_FK,
                            location_id: LOCATION_ID,
                        },
                    },
                });

                id = result?.data?.registerUserToClinic?.patient_id;


                if (!id) {
                    throw new Error('Failed to register user to clinic.');
                }
            } catch (error) {
                console.error("bookAppointmentRegisterError", JSON.stringify(error, null, 2));
            }
        }

        setData({
            patientId: id,
        });
        return id;


    };

    const addMedication = () => {
        setMedications([...medications, { medicineName: '', medicineDosage: '', medicineAmount: '', medicineNote: '' }]);
    };

    const handleMedicationChange = (index, field, value) => {
        const newMedications = medications.map((med, i) =>
            i === index ? { ...med, [field]: value } : med
        );
        setMedications(newMedications);
    };

    const handleNext = () => setStep(step + 1);
    const handlePrevious = () => setStep(step - 1);

    const handleNext1 = async () => {
        await handleAddressInput;
        setStep(step + 1);
    };

    // const handleSubmit = () => {
    //     //onClose();
    //     setSuccessModalOpen(true);
    // };

    // eslint-disable-next-line
    // const handlePlaceChanged = () => {
    //     const places = searchBoxRef.current?.getPlaces();
    //     if (places && places.length === 1) {
    //         const place = places[0];
    //         setAddress(place.formatted_address || '');
    //     }
    // };

    // eslint-disable-next-line
    const handleSuccessModalClose = () => {
        setSuccessModalOpen(false);
        onClose();

    };

    const handleAddressInput = async (address) => {
        if (deliveryMethod === 'post' && address.length >= 15) {
            try {
                const response = await axios.post('https://api.staging.app.familydoctor.com.au/location/validate', { address });

                const result = response.data.result;
                const addressComponents = result.address.addressComponents;

                // Check if essential components like route, locality, and postal code are confirmed
                const hasConfirmedRoute = addressComponents.some(
                    (component) => component.componentType === 'route' && component.confirmationLevel === 'CONFIRMED'
                );
                const hasConfirmedLocality = addressComponents.some(
                    (component) => component.componentType === 'locality' && component.confirmationLevel === 'CONFIRMED'
                );
                const hasConfirmedPostalCode = addressComponents.some(
                    (component) => component.componentType === 'postal_code' && component.confirmationLevel === 'CONFIRMED'
                );

                if (hasConfirmedRoute && hasConfirmedLocality && hasConfirmedPostalCode) {
                    const formattedAddress = result.address.formattedAddress;
                    setAddress(formattedAddress);
                    setValidationError('');
                    // console.log('Address validated:', formattedAddress);
                    setIsAddressValidated(true);
                    setValidationError(formattedAddress);
                } else {
                    setAddress(null);
                    setIsAddressValidated(false);
                    setValidationError('Invalid address. Please enter a valid address.');
                }
            } catch (error) {
                console.error('Error validating address:', error);
                setAddress(null);
                setIsAddressValidated(false);
                setValidationError('Invalid address. Please enter a valid address.');
            }
        }
    };

    

    // eslint-disable-next-line
    const handleSuccess = async (id: string) => {
        console.log('Handling success with payment ID:', id); // Log to check if this function is triggered

        let deliveryMthdData = '';

        if (deliveryMethod.toLowerCase().includes('fax')) {
            deliveryMthdData = faxNumber;
        } else if (deliveryMethod.toLowerCase().includes('escript - email')) {
            deliveryMthdData = email;
        } else if (deliveryMethod.toLowerCase().includes('escript - mobile')) {
            deliveryMthdData = mobile;
        } else if (deliveryMethod.toLowerCase().includes('post')) {
            deliveryMthdData = address;
        } else if (deliveryMethod.toLowerCase().includes('send to pharmacy')) {
            deliveryMthdData = address;
        } else if (deliveryMethod.toLowerCase().includes('send to home')) {
            deliveryMthdData = address;
        } else {
            deliveryMthdData = null;
        }

        const deliveryMethodIndex = scriptRulesData.scriptRules.script_delivery_mthds.findIndex(
            method => method.delivery_desc.toLowerCase() === deliveryMethod.toLowerCase()
        );
    

        try {
            await createScriptMutation({
                variables: {
                    input: {
                        clinic_group_crm: CLINIC_GROUP_CRM,
                        user_fk: USER_FK,
                        location_id: LOCATION_ID,
                        patient_id: patientId,
                        first_name: patient1.first_name,
                        last_name: patient1.last_name,
                        dob: patient1.dob,
                        mobile_phone: patient1.contact_number,
                        doctor_id: doctor.doctor_id,
                        payment_id: `${id}`,
                        delivery_mthd: `${deliveryMethodIndex}`,
                        delivery_mthd_data: deliveryMthdData ?? "None",
                        medications: medications.map(med => ({
                            medication_name: med.medicineName,
                            dosage: med.medicineDosage,
                            times_per_day: med.medicineAmount,
                            special_note: med?.medicineNote,
                        })),
                    },
                },
            });
            // GTAG EVENT
            (window as any).gtag('event', 'script', {
                clinic_group_crm: CLINIC_GROUP_CRM,
                user_fk: USER_FK,
                location_id: LOCATION_ID,
            });

            console.log('Payment and script creation successful, opening success modal');
            setSuccessModalOpen(true); // Ensure this is being called
        } catch (error) {
            console.error('Error creating script:', error);
        }
    };
    const handleError = () => console.log("error");


    const DoctorsList = () => {
        const { data: doctorsData, loading: doctorsLoading, error: doctorsError } = useDoctorsQuery({
            variables: {
                input: {
                    clinic_group_crm: CLINIC_GROUP_CRM,
                    user_fk: USER_FK,
                    location_id: LOCATION_ID,
                },
                filters: {
                    allow_online_app: '1',
                    allow_scripts: '1',
                },
            },
        });

        if (doctorsLoading) return <Loading />;
        if (doctorsError) return <Text>Error loading doctors: {doctorsError.message}</Text>;

        return (
            <div>
                {doctorsData?.doctors.map((doctor) => (
                    <Box
                        p={2}
                        display="flex"
                        flexDirection="row"
                        key={doctor.doctor_id}
                        justifyContent={'space-between'}
                        onClick={() => handleDoctorSelect(doctor)}
                        boxShadow="md"
                        borderRadius={10}
                        mt={2}
                        cursor="pointer"
                        borderWidth="1px"
                    >
                        <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                            <Avatar name={doctor.display_name} size="md" src={doctor.image} />
                            <Text fontWeight="bold" color={'gray'} ml={4}>
                                {doctor.display_name}
                            </Text>
                        </Box>
                        <IconButton
                            isRound={true}
                            variant="solid"
                            bg="#B92F2F"
                            aria-label="Done"
                            fontSize="20px"
                            onClick={() => handleDoctorSelect(doctor)}
                            icon={<PiStethoscopeBold color="#fff" />}
                        />
                    </Box>
                ))}
            </div>
        );
    };

    const handleDoctorSelect = async (doctor) => {
        setSelectedDoctor(doctor);
        setData({
            doctor: doctor
        });

        // Wait for registerPatient to complete
        const id = await registerPatient();

        // Now patientId should be set
        if (id) {
            handleNext();
        } else {
            showAlert({
                severity: "error",
                title: "Whoops",
                message: "Failed to register the patient. Please try again."
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" blockScrollOnMount={false} closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                {step === 1 && (
                    <>
                        <Alert
                            status="warning"
                            variant="subtle"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            textAlign="center"
                            borderTopRadius={'10px'}
                            p={5}
                        >
                            <AlertIcon boxSize="40px" mr={0} />
                            <AlertTitle mt={4} mb={1} fontSize="lg">
                                Disclaimer
                            </AlertTitle>
                            <AlertDescription maxWidth="sm">
                                <p dangerouslySetInnerHTML={{ __html: scriptRulesData?.scriptRules?.script_msg }} />
                            </AlertDescription>
                        </Alert>
                        <ModalFooter>
                            <Button variant="ghost" borderRadius={30} size="sm" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="solid"
                                size="sm"
                                bg="#B92F2F"
                                color="#fff"
                                aria-label="Done"
                                fontSize="sm"
                                borderRadius={30}
                                onClick={handleNext}
                                marginLeft={5}
                            >
                                Next
                            </Button>
                        </ModalFooter>
                    </>
                )}
                {step === 2 && (
                    <>
                        <ModalHeader>Please select your Doctor</ModalHeader>
                        <ModalBody>
                            <Stack>
                                <DoctorsList />
                            </Stack>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="ghost" onClick={handlePrevious}>
                                Back
                            </Button>
                        </ModalFooter>
                    </>
                )}
                {step === 3 && (
                    <>
                        <ModalHeader>Please list required Medications</ModalHeader>
                        <ModalBody>
                            <Box fontSize={'small'}>You must enter Medication, Dosage & Times / Day (between 1 & 10) for each Medication taken.</Box>
                            {/* <Box>{patient1.first_name} {clinic1.kiosk_serial_no} {doctor.doctor_id} {patientId}</Box> */}
                            <Alert status='info' fontSize={"small"} fontWeight={"bold"} mb={3} mt={3}>
                                <AlertIcon />
                                You can only request up to 5 medications.
                            </Alert>
                            <Stack spacing={4}>
                                {medications.map((med, index) => (
                                    <Box key={index} border="1px solid #E2E8F0" p={4} borderRadius="md" position="relative">
                                        <IconButton
                                            icon={<IoMdClose onClick={() => removeMedication(index)} />}
                                            aria-label="Remove Medication"
                                            size="xs"
                                            position="absolute"
                                            top="8px"
                                            right="8px"
                                            bg="gray.300"
                                            color="white"
                                            cursor="pointer"
                                            zIndex={1}
                                            _hover={{ bg: "red.600" }}
                                            onClick={() => removeMedication(index)}
                                        />

                                        <FormControl>
                                            <FormLabel fontSize={"small"}>Medication</FormLabel>
                                            <Input
                                                value={med.medicineName}
                                                variant="filled"
                                                onChange={(e) => handleMedicationChange(index, 'medicineName', e.target.value)}
                                            />
                                        </FormControl>
                                        <Box display={'flex'} gap={3}>
                                            <FormControl>
                                                <FormLabel fontSize={"small"} mt={3}>Dosage</FormLabel>
                                                <Input
                                                    value={med.medicineDosage}
                                                    variant="filled"
                                                    onChange={(e) => handleMedicationChange(index, 'medicineDosage', e.target.value)}
                                                />
                                            </FormControl>
                                            <FormControl>
                                                <FormLabel fontSize={"small"} mt={3}>Times/Day</FormLabel>
                                                <Input
                                                    value={med.medicineAmount}
                                                    variant="filled"
                                                    onChange={(e) => handleMedicationChange(index, 'medicineAmount', e.target.value)}
                                                />
                                            </FormControl></Box>
                                        <FormControl>
                                            <FormLabel fontSize={"small"} mt={3}>Special Note</FormLabel>
                                            <Input
                                                value={med.medicineNote}
                                                variant="filled"
                                                onChange={(e) => handleMedicationChange(index, 'medicineNote', e.target.value)}
                                            />
                                        </FormControl>
                                    </Box>
                                ))}
                                <Button leftIcon={<IoIosAddCircle />} bg="#B92F2F" color="#fff" onClick={addMedication}>
                                    Add Medication
                                </Button>
                            </Stack>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="ghost" borderRadius={30} size="sm" onClick={handlePrevious}>
                                Back
                            </Button>
                            <Button
                                variant="solid"
                                size="sm"
                                bg="#B92F2F"
                                color="#fff"
                                aria-label="Done"
                                fontSize="sm"
                                borderRadius={30}
                                onClick={handleNext}
                                marginLeft={5}
                                isDisabled={
                                    medications.length === 0 ||
                                    medications.some(
                                        (med) => !med.medicineName || !med.medicineDosage || !med.medicineAmount
                                    )
                                }>
                                Next
                            </Button>
                        </ModalFooter>
                    </>
                )}
                {step === 4 && (
                    <>
                        <ModalHeader>Please choose Delivery Method</ModalHeader>
                        <ModalBody>
                            <RadioGroup onChange={setDeliveryMethod} value={deliveryMethod}>
                                <Stack direction="column" spacing={4}>
                                    {scriptRulesData.scriptRules.script_delivery_mthds.map((method, index) => {
                                        if (method.enabled === '1') {
                                            return (
                                                <Box
                                                    key={index}
                                                    as="button"
                                                    cursor="pointer"
                                                    borderWidth="1px"
                                                    borderRadius="md"
                                                    boxShadow="md"
                                                    fontWeight={'bold'}
                                                    p={'10px'}
                                                    bg={deliveryMethod === method.delivery_desc.toLowerCase() ? '#B92F2F' : 'white'}
                                                    color={deliveryMethod === method.delivery_desc.toLowerCase() ? 'white' : 'black'}
                                                    borderColor={deliveryMethod === method.delivery_desc.toLowerCase() ? 'teal.600' : 'gray.200'}
                                                    _hover={{ borderColor: 'teal.600' }}
                                                    onClick={() => {
                                                        setDeliveryMethod(method.delivery_desc.toLowerCase())
                                                        deliveryMethodObjRef.current = method;
                                                        setmobile(patient1.contact_number);


                                                    }}
                                                >
                                                    {method.delivery_desc} (${method.fee})
                                                    {(method.delivery_desc.toLowerCase() === 'fax' && deliveryMethod === 'fax') && (
                                                        <Input
                                                            bg="white"
                                                            color="black"
                                                            value={faxNumber}
                                                            placeholder="Enter Fax No."
                                                            mt={2}
                                                            onChange={(e) => setfaxNumber(e.target.value)}
                                                        />
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - email' && deliveryMethod === 'escript - email') && (
                                                        <>
                                                            <Input
                                                                bg="white"
                                                                color="black"
                                                                value={email}
                                                                placeholder="Enter your Email."
                                                                mt={2}
                                                                onChange={handleEmailChange}
                                                            />
                                                            {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                                        </>
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - email [urgent]' && deliveryMethod === 'escript - email [urgent]') && (
                                                        <>
                                                            <Input
                                                                bg="white"
                                                                color="black"
                                                                value={email}
                                                                placeholder="Enter your Email."
                                                                mt={2}
                                                                onChange={handleEmailChange}
                                                            />
                                                            {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                                        </>
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - email to pharmacy' && deliveryMethod === 'escript - email to pharmacy') && (
                                                        <>
                                                            <Input
                                                                bg="white"
                                                                color="black"
                                                                value={email}
                                                                placeholder="Enter your Email."
                                                                mt={2}
                                                                onChange={handleEmailChange}
                                                            />
                                                            {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                                        </>
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - email to pharmacy [urgent]' && deliveryMethod === 'escript - email to pharmacy [urgent]') && (
                                                        <>
                                                            <Input
                                                                bg="white"
                                                                color="black"
                                                                value={email}
                                                                placeholder="Enter your Email."
                                                                mt={2}
                                                                onChange={handleEmailChange}
                                                            />
                                                            {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                                        </>
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - mobile' && deliveryMethod === 'escript - mobile') && (

                                                        <Input
                                                            bg="white"
                                                            color="black"
                                                            value={patient1.contact_number}
                                                            placeholder="Enter your Mobile."
                                                            mt={2}
                                                            onChange={(e) => setmobile(e.target.value)}

                                                        />
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'escript - mobile [urgent]' && deliveryMethod === 'escript - mobile [urgent]') && (
                                                        <Input
                                                            bg="white"
                                                            color="black"
                                                            value={patient1.contact_number}
                                                            placeholder="Enter your Mobile."
                                                            mt={2}
                                                            onChange={(e) => setmobile(e.target.value)}
                                                        />
                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'post' && deliveryMethod === 'post') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'post [urgent]' && deliveryMethod === 'post [urgent]') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'send to home' && deliveryMethod === 'send to home') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'send to home [urgent]' && deliveryMethod === 'send to home [urgent]') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'send to Pharmacy' && deliveryMethod === 'send to Pharmacy') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                    {(method.delivery_desc.toLowerCase() === 'send to Pharmacy [urgent]' && deliveryMethod === 'send to Pharmacy [urgent]') && (
                                                        <>
                                                            <Box flexDirection={'row'}>
                                                                <InputGroup>
                                                                    <Input
                                                                        placeholder="Enter Address"
                                                                        mt={2}
                                                                        bg="white"
                                                                        color="black"
                                                                        onChange={(e) => {
                                                                            const newAddress = e.target.value;
                                                                            setAddress(newAddress);
                                                                            handleAddressInput(newAddress);
                                                                        }}
                                                                    />
                                                                    {isAddressValidated && (
                                                                        <InputRightElement mt={2}>
                                                                            <FaCheck color="green" />
                                                                        </InputRightElement>
                                                                    )}
                                                                </InputGroup>
                                                            </Box>
                                                            {validationError && (
                                                                <Text color="#fff" fontSize="sm" mt={2} >
                                                                    {validationError}
                                                                </Text>
                                                            )}
                                                        </>

                                                    )}
                                                </Box>
                                            );
                                        }
                                        return null;
                                    })}
                                </Stack>
                            </RadioGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Box flex="1" textAlign="left">
                                <Text fontSize="lg" fontWeight={'bold'} color="red.500">
                                    {scriptRulesData.scriptRules.script_delivery_mthds.map((method) => {
                                        if (method.delivery_desc.toLowerCase() === deliveryMethod) {
                                            return `$${method.fee}`;
                                        }
                                        return null;
                                    })}
                                </Text>
                            </Box>
                            <Button
                                variant="ghost"
                                aria-label="Done"
                                fontSize="sm"
                                size="sm"
                                borderRadius={30}
                                onClick={handlePrevious}
                            >
                                Back
                            </Button>
                            <Button
                                variant="solid"
                                size="sm"
                                bg="#B92F2F"
                                color="#fff"
                                aria-label="Done"
                                fontSize="sm"
                                borderRadius={30}
                                ml={'5px'}
                                onClick={handleNext1}
                                isDisabled={
                                    (deliveryMethod === 'fax' && !faxNumber) ||
                                    (deliveryMethod === 'post' && (!address || validationError === 'Invalid address. Please enter a valid address.'))
                                }
                            >
                                Make Payment
                            </Button>
                        </ModalFooter>
                    </>
                )}
                {step === 5 && (
                    <>
                        <ModalHeader>Payment Confirmation</ModalHeader>
                        <ModalBody>
                            <Text mb={2}>Please confirm the details below before proceeding to payment</Text>

                            <Box mb={4}>
                                <Text fontWeight="bold">Patient Details</Text>
                                <Text ml={3}>Full Name: {patient1?.first_name} {patient1?.last_name}</Text>
                                <Text ml={3}>Date of Birth: {patient1?.dob}</Text>
                                
                            </Box>
                            <Divider />

                            <Box mb={4} mt={4}>
                                <Text fontWeight="bold">Doctor Details</Text>
                                <Text ml={3}>Name: {doctor?.display_name}</Text>
                                <Text ml={3}>Clinic: {clinic1?.location_display_name}</Text>
                            </Box>
                            <Divider />

                            <Box mb={4} mt={4}>
                                <Text fontWeight="bold">Medication Details</Text>
                                {medications.map((med, index) => (
                                    <Box key={index} mb={2} bg={"#f0f0f0"} borderWidth="1px" boxShadow={"md"} p={5} mt={2} borderRadius={8}>
                                        <Text>Medication Name: {med.medicineName}</Text>
                                        <Text>Dosage: {med.medicineDosage}</Text>
                                        <Text>Dosage: {med.medicineAmount}</Text>
                                        <Text>Dosage: {med.medicineNote}</Text>
                                    </Box>
                                ))}
                            </Box>
                            <Divider />

                            <Box mb={4} mt={4}>
                                <Text fontWeight="bold">Your Order</Text>
                                <Text ml={3}>Delivery Method: {deliveryMethod}</Text>
                                {deliveryMethod.toLowerCase().includes('fax') && (
                                    <Text ml={3}>Fax Number: {faxNumber}</Text>
                                )}
                                {deliveryMethod.toLowerCase().includes('mobile') && (
                                    <Text ml={3}>Mobile Number: {mobile}</Text>
                                )}
                                {deliveryMethod.toLowerCase().includes('email') && (
                                    <Text ml={3}>E mail: {email}</Text>
                                )}
                                {deliveryMethod.toLowerCase().includes('post') && (
                                    <Text ml={3}>Post Address: {address}</Text>
                                )}
                                {deliveryMethod.toLowerCase().includes('send to pharmacy') && (
                                    <Text ml={3}>Post Address: {address}</Text>
                                )}
                                {deliveryMethod.toLowerCase().includes('send to home') && (
                                    <Text ml={3}>Post Address: {address}</Text>
                                )}
                                <Text fontSize="lg" fontWeight={'bold'} ml={3}> Total Cost :
                                    {scriptRulesData.scriptRules.script_delivery_mthds.map((method) => {
                                        if (method.delivery_desc.toLowerCase() === deliveryMethod) {
                                            return `$${method.fee}`;
                                        }
                                        return null;
                                    })}
                                </Text>
                            </Box>
                            <Text mb={4}>If the details are correct, please proceed to payment.</Text>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                variant="ghost"
                                aria-label="Back"
                                fontSize="sm"
                                size="sm"
                                borderRadius={30}
                                onClick={handlePrevious}
                            >
                                Back
                            </Button>
                            <Button
                                variant="solid"
                                size="sm"
                                bg="#B92F2F"
                                color="#fff"
                                aria-label="Done"
                                fontSize="sm"
                                borderRadius={30}
                                ml={'5px'}
                                onClick={handleNext}
                            >
                                Proceed to Payment
                            </Button>
                        </ModalFooter>
                    </>
                )}
                {step === 6 && (
                    <>
                        <ModalHeader>Enter card details</ModalHeader>
                        <ModalBody>
                            <PaymentStep
                                clinic={clinic1}
                                patient={patient1}
                                patientId={patientId}
                                doctor={doctor}
                                locationId={LOCATION_ID}
                                pmethod={'1'}
                                aptypeid={'0'}
                                bid={'0'}
                                fees={deliveryMethodObjRef.current.fee}
                                isSuccessModalOpen={isSuccessModalOpen}
                                onSuccessModalClose={handleSuccessModalClose}
                                handleSuccess={handleSuccess}
                                handleError={handleError}
                                handlePrevious={handlePrevious}
                            />
                            <Flex justify='space-between' mb={5}>

                                <Button variant="ghost" aria-label="Back" fontSize="sm" size="sm" borderRadius={30} onClick={handlePrevious}>
                                    Back
                                </Button>
                                <Button bg="#B92F2F"
                                    color="#fff" aria-label="Back" fontSize="sm" size="sm" borderRadius={30} onClick={onClose}>
                                    Cancel Payment
                                </Button></Flex>
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default RepeatScriptModal;
